import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { CogWheelIcon } from "@common/cogWheelIcon";
import { CloseAll, OpenAll, useControls } from "@common/treeToggle";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function Heading({ columns, label, unfoldAll }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();
  const controls = useControls();

  return (
    <div className={styles.heading}>
      <div className={styles.nameHeading}>
        <p className={styles.label}>
          {t("planzoneMembersPage.resources.name")}
        </p>
        <div className={styles.controls}>
          <CloseAll
            isDisabled={!controls.canCollapse}
            toggle={controls.collapseAll}
          />
          <OpenAll
            isDisabled={!controls.canOpen}
            toggle={() => {
              unfoldAll();
              controls.extendAll();
            }}
          />
        </div>
      </div>
      {columns.map(({ key }) => (
        <p key={key} className={styles.label}>
          {label(key)}
        </p>
      ))}
      <Safeguard useCases={[UseCases.editResourcesListingConfiguration]}>
        {({ canEditResourcesListingConfiguration }) => (
          <div className={styles.cogWheel}>
            {canEditResourcesListingConfiguration && (
              <div
                onClick={() =>
                  pushView({
                    key: UseCases.retrieveResourcesListingConfiguration,
                    data: undefined,
                  })
                }
              >
                <CogWheelIcon className={styles.cogIcon} />
              </div>
            )}
          </div>
        )}
      </Safeguard>
    </div>
  );
}

export { Heading };
